import ContentPageLayout from 'components/ContentPageLayout'

const LegalNotice = (): JSX.Element => {
	return <ContentPageLayout contentKey="legal_notice" />
}

export default LegalNotice
